import { render } from "./ProductExpectedRunRates.vue?vue&type=template&id=665237fa"
import script from "./ProductExpectedRunRates.vue?vue&type=script&lang=js"
export * from "./ProductExpectedRunRates.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QBtn});
